var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.11111 2C4.73604 2 2 4.73604 2 8.11111C2 11.4862 4.73604 14.2222 8.11111 14.2222C11.4862 14.2222 14.2222 11.4862 14.2222 8.11111C14.2222 4.73604 11.4862 2 8.11111 2ZM0 8.11111C0 3.63147 3.63147 0 8.11111 0C12.5908 0 16.2222 3.63147 16.2222 8.11111C16.2222 12.5908 12.5908 16.2222 8.11111 16.2222C3.63147 16.2222 0 12.5908 0 8.11111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4262 12.4267C12.8167 12.0362 13.4499 12.0362 13.8404 12.4267L17.7071 16.2933C18.0976 16.6839 18.0976 17.317 17.7071 17.7076C17.3166 18.0981 16.6834 18.0981 16.2929 17.7076L12.4262 13.8409C12.0357 13.4504 12.0357 12.8172 12.4262 12.4267Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44434 8.11133C4.44434 7.55904 4.89205 7.11133 5.44434 7.11133H10.7777C11.33 7.11133 11.7777 7.55904 11.7777 8.11133C11.7777 8.66361 11.33 9.11133 10.7777 9.11133H5.44434C4.89205 9.11133 4.44434 8.66361 4.44434 8.11133Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.ea31d12463e516a8654f513555b4bbed.svg";
export { ForwardRef as ReactComponent };